module.exports = __webpack_public_path__ + "static/media/wellness.44d0e62a.png";